module.exports = "<app-section>\n  <app-main></app-main>\n</app-section>\n\n<app-section id=\"rm-about\">\n  <app-about></app-about>\n</app-section>\n\n<app-section id=\"rm-education\">\n  <app-education></app-education>\n</app-section>\n\n<app-section id=\"rm-portfolio\">\n  <app-portfolio></app-portfolio>\n</app-section>\n\n<app-section id=\"rm-contact\">\n  <app-contact></app-contact>\n</app-section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main